export default "__VITE_ASSET__4adcf536__"